import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { separateLeftRightSelectionState } from '@upright/ui/common/upright/core/impact-lens-profile/selection-state/separate-left-right-selection-state';
import { TargetsSymbol } from '@upright/ui/common/upright/core/impact-lenses/targets/data-area/targets-symbol';
import { TargetsEmptyState } from '@upright/ui/common/upright/core/impact-lenses/targets/empty-state';
import { TargetsInfoBoxes } from '@upright/ui/common/upright/core/impact-lenses/targets/info-boxes';
import { TargetsInfoBoxConnectors } from '@upright/ui/common/upright/core/impact-lenses/targets/info-boxes/connectors';
import { targetLensTexts } from '@upright/ui/common/upright/core/impact-lenses/targets/texts';
import { TargetsLensData, TargetsLensOptions } from '@upright/ui/common/upright/core/impact-lenses/targets/types';
import { ImpactLens } from '@upright/ui/common/upright/core/impact-lenses/types';
import { isTargetsDataAreaClickable } from './selection-state';

export const targetsLens: ImpactLens<ImpactLensType.TARGETS, TargetsLensData, TargetsLensOptions> = {
  type: ImpactLensType.TARGETS,
  ImpactDataComponent: { component: TargetsSymbol },
  infoBoxes: { DivComponent: TargetsInfoBoxes, SvgComponent: TargetsInfoBoxConnectors },
  maxDataAreaWidth: (_fullWidth: number) => {
    return 30;
  },
  boxMode: (fullWidth: number) => {
    if (fullWidth < 700) {
      return LensBoxMode.MODAL;
    }
    return LensBoxMode.SIDE;
  },
  boxesAreaWidth: (_fullWidth: number) => {
    return 310;
  },
  EmptyState: TargetsEmptyState,

  isImpactDataAreaClickable: isTargetsDataAreaClickable,
  ...separateLeftRightSelectionState,
  ...targetLensTexts,
};
